import type { ServiceSectionItem } from "@/api/types";
import { formatPrice } from "@/features/bookings/utils";

type ServiceDisplay = Pick<
  ServiceSectionItem,
  "duration" | "duration_minutes" | "price_display" | "price_cents" | "currency"
>;

export function formatServiceDisplay(service: ServiceDisplay) {
  return {
    duration:
      service.duration?.trim() ||
      (service.duration_minutes != null ? `${service.duration_minutes} min` : null),
    price:
      service.price_display?.trim() ||
      (service.price_cents != null ? formatPrice(service.price_cents, service.currency) : null),
  };
}
